import React, { Fragment, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { SwipeableDrawer, Divider, Paper, Avatar, Typography } from '@mui/material';

import useRouter from 'utils/useRouter';
import { Navigation } from 'components';
import navigationConfig from './navigationConfig';

import { reverseUserRoute } from 'routes';
import ResponsiveHidden from 'components/ResponsiveHidden';
// import cow from "assets/img/avatars/svg/001-cow.svg"

const useStyles = makeStyles(theme => ({
  root: {
    overflowY: 'auto'
  },
  content: {
    padding: theme.spacing(2),
  },
  profile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: {
    marginTop: theme.spacing(1),
  },
  version: {
    textAlign: "center",
  },
  divider: {
    marginTop: theme.spacing(2),
  },
  navigation: {
    marginTop: theme.spacing(2),
    minHeight: '90vh'
  },
  navMenuItem: {
    '& a': {
      padding: "15px 5px"
    },
    '& button': {
      padding: "15px 5px"
    },
  },

  /** -----------------------------------------
   * NEW: Desktop sidebar open/close classes
   * ---------------------------------------- */
  desktopSidebar: {
    width: 260,
    minWidth: 260,
    flexShrink: 0,
    transition: 'width 0.3s ease',
  },

  desktopSidebarHidden: {
    width: 0,
    minWidth: 0,
    flexShrink: 0,
    overflow: 'hidden',
    transition: 'width 0.3s ease',
  }
}));

const NavBar = props => {
  const { openMobile, onMobileClose, onMobileOpen, toggleState:{ showDesktopSidebar, setShowDesktopSidebar }, className, ...rest } = props;

  const classes = useStyles();
  const router = useRouter();
  const admin = useSelector(state => state.adminAuthReducer.currentAdmin);

  useEffect(() => {
    if (openMobile) {
      onMobileClose && onMobileClose();
    }
  }, [router.location.pathname]);

  let avatar;

  if (admin.id) {
    avatar =
      <Avatar
        alt="Person"
        className={classes.avatar}
        component={RouterLink}
        src={admin.avatar?.url ? admin.avatar.url : require(`assets/img/avatars/00${admin.id % 46 + 1}.svg`)}
        to={reverseUserRoute('Profile', 2)}
      />
  }

  const navbarContent = (
    <>
      <div className='menuBar'>
        <Typography
          className='name'
          variant="h4"
        >Menu</Typography>
        <Divider className='divider' />
        <nav className='navigation'>
          {navigationConfig.map((list, i) => (
            <Navigation
              component="div"
              key={`${list.title}_${i}`}
              pages={list.pages}
              title={list.title}
              icon={list.icon}
              className='navMenuItem'
            />
          ))}
        </nav>

        <Typography
          className='version'
          variant="body2"
        >Version 2.0</Typography>
      </div>
    </>
  );

  return (
    <Fragment>
      <ResponsiveHidden lgUp={true}>
        <SwipeableDrawer
          anchor="left"
          onClose={onMobileClose}
          onOpen={onMobileOpen}
          open={openMobile}
          variant="temporary"
        >
          <div
            {...rest}
            className={clsx(classes.root, className)}
          >
            {navbarContent}
          </div>
        </SwipeableDrawer>
      </ResponsiveHidden>
      <ResponsiveHidden mdDown={true}>
        <Paper
          {...rest}
          className={clsx(
            classes.root,
            className,
            showDesktopSidebar ? classes.desktopSidebar : classes.desktopSidebarHidden
          )}
          elevation={1}
          square
        >
          {navbarContent}
        </Paper>
      </ResponsiveHidden>
    </Fragment>
  );
};

NavBar.propTypes = {
  className: PropTypes.string,
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

export default NavBar;
